/** Progress the child can see without reading a number. */
export function Meter({ done, total, accent }: { done: number; total: number; accent: string }) {
  const percent = total === 0 ? 0 : Math.round((done / total) * 100)
  return (
    <div
      className="bg-rule h-3 w-full overflow-hidden rounded-full"
      role="progressbar"
      aria-valuenow={done}
      aria-valuemin={0}
      aria-valuemax={total}
      aria-label={`${done} de ${total}`}
    >
      <div
        className="h-full rounded-full transition-[width] duration-300"
        style={{ width: `${percent}%`, background: accent }}
      />
    </div>
  )
}
